<template>
    <div>
        <page-header
            :title="
                user.first_name +
                    ' ' +
                    user.last_name +
                    ' ' +
                    $t('pages.account.title')
            "
            :use-title-as-document-title="false"
            icon-class="mdi mdi-account"
        />

        <div class="row mb-4">
            <div class="col-md-3">
                <div class="list-group">
                    <router-link
                        tag="a"
                        :to="link.route"
                        class="list-group-item d-flex justify-content-between align-items-center oswald text-primary"
                        :class="{
                            active: isActive(link),
                            'text-danger': link.icon === 'mdi-heart' && healthProblem(link)
                        }"
                        v-for="link in links"
                        :key="link.title"
                    >
                        {{ link.title }}
                        <span
                            class="badge badge-primary badge-dark badge-pill"
                            :class="{
                                'text-danger':
                                    link.icon === 'mdi-heart' &&
                                    healthProblem(link)
                            }"
                        >
                            <i class="mdi mdi-18px" :class="link.icon"></i>
                        </span>
                    </router-link>
                </div>
            </div>

            <div class="col-md-9">
                <transition name="component-fade" mode="out-in">
                    <router-view :user="user"></router-view>
                </transition>
            </div>
        </div>
    </div>
</template>

<script>
import PageHeader from "../../Includes/PageHeader";
import AdminUsersRepository from "../../../repositories/Admin/AdminUsersRepository";

export default {
    name: "User",
    components: {PageHeader},
    data: () => ({
        user: {}
    }),
    computed: {
        links() {
            return [
                {
                    icon: "mdi-account",
                    title: this.$t("pages.account.info.title"),
                    route: {name: "admin.user.info"}
                },
                {
                    icon: "mdi-mine",
                    title: this.$t("pages.subscription.title"),
                    route: {name: "admin.user.subscription"},
                    activeWord: "subscription"
                },
                {
                    icon: "mdi-heart",
                    title: this.$t("pages.account.health.title"),
                    route: {name: "admin.user.health"}
                },
                {
                    icon: "mdi-chart-timeline-variant",
                    title: this.$t("pages.locker.my_aform.training_stats"),
                    route: {name: "admin.user.aform"}
                }
            ];
        }
    },
    methods: {
        isActive(link) {
            if (link.activeWord === undefined)
                return this.$route.name === link.route.name;

            return this.$route.name.includes(link.activeWord);
        },
        getUser() {
            AdminUsersRepository.getUser(this.$route.params.user).then(
                res => (this.user = res.data)
            );
        },
        healthProblem() {
            if (!this.user.question_answers) return

            for (const answer of this.user.question_answers) {
                if (answer) return true;
            }
        }
    },
    mounted() {
        this.getUser();
    }
};
</script>

<style scoped></style>
